export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-21-0ba9f5c4da2867c9565e02ceb21a0ded.png";